import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { assert } from 'ts-essentials';

const PhoneNumber = {
  joinMedishare: '800-772-5623',
  memberServices: '800-264-2562',
} as const;

type PhoneNumberKey = keyof typeof PhoneNumber;

type PhoneData = {
  href: string;
  number: string;
};

export type PhoneNumbers = Record<PhoneNumberKey, PhoneData>;

const generatePhoneNumbers = (): PhoneNumbers => {
  const phoneData: Partial<PhoneNumbers> = {};
  for (const [key, value] of Object.entries(PhoneNumber)) {
    const phoneNumber = parsePhoneNumberWithError(value, 'US');
    assert(phoneNumber);

    phoneData[key as PhoneNumberKey] = {
      href: phoneNumber.getURI(),
      number: phoneNumber.formatNational(),
    };
  }
  return phoneData as PhoneNumbers;
};

export const phoneNumbers = generatePhoneNumbers();

const Email = {
  memberServices: 'memberservices@mychristiancare.org',
} as const;

type EmailData = {
  address: string;
  href: string;
};

type EmailKey = keyof typeof Email;

export type Emails = Record<EmailKey, EmailData>;

const generateEmails = (): Emails => {
  const emailData: Partial<Emails> = {};
  for (const [key, value] of Object.entries(Email)) {
    emailData[key as EmailKey] = {
      address: value,
      href: `mailto:${value}`,
    };
  }
  return emailData as Emails;
};

export const emails = generateEmails();
